<!-- TODO: этот файл создан на замену устаревшего компонента molecules/common/ScreenHeader.vue необходимо постепенно избавляться от старого и внедрять новый комонент -->
<template>
  <div
    :class="$style.container"
    @click.stop="handleNavigate"
  >
    <div :class="$style.content">
      <div :class="$style.navigate">
        <base-icon
          :size="16"
          name="arrows_arrow-left"
        />
      </div>
      <h1
        :class="$style.title"
        v-text="title"
      />
    </div>
    <div
      v-if="$slots.hasOwnProperty('toolbar')"
      :class="$style.toolbar"
    >
      <slot name="toolbar" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScreenHeader',
  props: {
    title: String,
    historyMode: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleNavigate() {
      if (this.historyMode) {
        this.$router.go(-1);
        return;
      }

      this.$emit('navigate');
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    +align-items(center)
    +justify-content(space-between)
    cursor: pointer

  .content
    overflow: hidden

  .toolbar

  .title
    +text-ellipsis
    +font-type('regular', 20, 24)
    color: var(--color-white)

    +respond-to(medium)
      line-height: 60px

  .navigate
    margin-bottom: 4px
    fill: var(--color-icon-primary)

  .toolbar
    flex: none
</style>
